"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconYoutube = void 0;
var React = __importStar(require("react"));
var IconYoutube = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M15.0748,12.3898 L10.8238,14.5408 C10.4023,14.7508 10.0543,14.5588 10.0543,14.1088 L10.0543,9.8893 C10.0543,9.4393 10.4023,9.2488 10.8238,9.4588 L15.0748,11.6083 C15.4963,11.8303 15.4963,12.1708 15.0748,12.3898 M20.6938,8.0293 C20.4733,7.1293 19.6813,6.4813 18.7423,6.3793 C16.5073,6.1393 14.2528,5.9998 12.0043,5.9998 C9.7468,5.9998 7.4908,6.1408 5.2573,6.3793 C4.3183,6.4813 3.5368,7.1293 3.3163,8.0293 C2.9998,9.2998 2.9998,10.6903 2.9998,11.9998 C2.9998,13.3093 2.9998,14.7013 3.3163,15.9718 C3.5278,16.8703 4.3183,17.5198 5.2573,17.6203 C7.4923,17.8603 9.7468,17.9998 11.9938,17.9998 C14.2528,17.9998 16.5088,17.8588 18.7423,17.6203 C19.6813,17.5198 20.4643,16.8703 20.6833,15.9718 C20.9998,14.7013 20.9998,13.3093 20.9998,11.9998 C20.9998,10.6903 20.9998,9.2998 20.6938,8.0293" }))); };
exports.IconYoutube = IconYoutube;
exports.IconYoutube.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconYoutube;
